export type State = {
  colorpickerBody: string | null | undefined;
  colorpickerEdge: string | null | undefined;
  colorpickerEdgeGlosiness: string | null | undefined;
  colorpickerEdgeMetalness: string | null | undefined;
  colorpickerThread: string | null | undefined;
  colorpickerInside: string | null | undefined;
  colorpickerTack: string | null | undefined;
}

export const state: State = {
  colorpickerBody: undefined,
  colorpickerEdge: undefined,
  colorpickerEdgeGlosiness: undefined,
  colorpickerEdgeMetalness: undefined,
  colorpickerThread: undefined,
  colorpickerInside: undefined,
  colorpickerTack: undefined,
};
